<template>
  <div class="is-marginless is-paddingless" v-if="dispositifs">
    <div class="columns">
      <div class=" column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('detailClient.generalTitle.dispositifs')}}
            </p>
          </header>
          <div class="level mgt-25px mgb-0 mgh-5">
            <div class="level-left">
              <selecteur-action
                :options="actions"
                :placeholder='$t("general.placeHolder.groupedAction")'
                :elementsSelectionnes="hasSelected"
                titleButton="general.button.apply"
                @handleAction="handleAction">
              </selecteur-action>
            </div>
            <div class="level-right">
              <exportExcelButton
              :perm="permEmplacement.exporter"
              :query="exportExcelQuery"/>
            </div>
          </div>
          <div class="card-content">
            <div class="mgt-10px VueTables">
              <div class="table-responsive">
                <v-client-table :data="dispositifs"
                  :columns="columns"
                  :options="options"
                  ref="tableDispositif"
                  class="tableWithChildRow">
                  <template slot="selected" slot-scope="props">
                    <b-checkbox
                      :value="props.row.selected"
                      @input="updateSelected(props.row)">
                    </b-checkbox>
                  </template>
                  <template slot="code" slot-scope="props">
                    <router-link-blank :to="{ name: 'c.gabed.emplacement-detailDispositif',
                      params: { id: props.row.emplacementId,
                        idDispositif: props.row.id }}"
                      :class="{'text-access-no-permission':
                        !checkPermissions(permEmplacement.lecture)}"
                      :message="props.row.code ">
                    </router-link-blank>
                  </template>
                  <template slot="nom" slot-scope="props">
                    {{ props.row.nom }}
                  </template>
                  <template slot="nbFaces" slot-scope="props">
                    {{ props.row.materiels.length }}
                  </template>
                  <template slot="adresse" slot-scope="props">
                    {{ getAdresse(props.row.adresse) }}
                  </template>
                  <template slot="etat" slot-scope="props">
                    {{ $t(getEtatMontage(props.row.etat)) }}
                  </template>
                  <template slot="dispositifType.libelle" slot-scope="props">
                    {{ getDispositifTypeLibelle(props.row.dispositifTypeId) }}
                  </template>
                  <template slot="agence" slot-scope="props">
                    {{ getAgenceLibelle(props.row.emplacement.agenceId) }}
                  </template>
                  <template slot="actif" slot-scope="props">
                    {{ props.row.actif ? $t('general.non') : $t('general.oui') }}
                  </template>
                  <template slot="dispositifSupport.libelle" slot-scope="props">
                    {{ props.row.dispositifSupport ? props.row.dispositifSupport.libelle : '' }}
                  </template>
                  <template slot="nomCommercial" slot-scope="props">
                    {{ getNomCommercial(props.row.emplacement.clientId) }}
                  </template>
                  <template #typeMateriel="{ row }">
                    {{ getAllTypeMateriel(row.materiels) }}
                  </template>
                  <template #eclairerOuNon="{ row }">
                    {{ getAllEclairage(row.materiels) }}
                  </template>
                  <template #formats="{ row }">
                    {{ getAllFormats(row.materiels) }}
                  </template>
                  <template #tailles="{ row }">
                    {{ getAllTailles(row.materiels) }}
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpCreationDemandeImpression" has-modal-card class="modal">
      <editionDemandeImpressionDispo
       :clientId="tiersInformation.id"
       :dispositifs ="dispositifsSelected">
      </editionDemandeImpressionDispo>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_MASS_CREATION_DEMANDE_IMPRESSION } from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { columnsSplice } from '@/services/general/columns';
import { getWithLiensInferieurs } from '@/api/tiers/index';
import { getAll } from '@/api/gabed/dispositif';
import materielsForClients from '@/components/tiers/c_materielsForClients';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import editionDemandeImpressionDispo from '@/components/clients/clients/detailClient/p_editionDemandeImpressionDispo';
import { formatTaillesMateriels } from '@/services/gabed/dispositif/dispositifService';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Dispositif = createNamespacedHelpers('dispositif');

export default {
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dispositifs: [],
      permEmplacement: EMPLACEMENT,
      listTiers: [],
      tabCustomerIds: [],
      popUpCreationDemandeImpression: false,
      isError: false,
      messages: [],
      actions: [
        { action: ACTION_MASS_CREATION_DEMANDE_IMPRESSION, translation: 'detailClient.dispositif.actions.createDemandeImpression' },
      ],
    };
  },
  components: {
    routerLinkBlank,
    exportExcelButton,
    selecteurAction,
    editionDemandeImpressionDispo,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Dispositif.mapGetters({
      lastPayload: 'lastPayload',
    }),
    columns() {
      const columns = ['selected', 'code', 'nom', 'nomCommercial', 'nbFaces', 'dispositifType.libelle', 'etat', 'formats', 'typeMateriel', 'tailles', 'eclairerOuNon', 'actif'];
      if (this.agencesSelectionnees.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    iconSelectTotal() {
      if (this.allSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allSelected() {
      return this.dispositifs.length > 0 && this.dispositifs.every(d => d.selected);
    },
    hasSelected() {
      return this.dispositifs.some(d => d.selected);
    },
    dispositifsSelected() {
      return this.dispositifs.filter(d => d.selected);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          code: this.$i18n.t('detailClient.dispositif.tab.code'),
          nom: this.$i18n.t('detailClient.dispositif.tab.nom'),
          nbFaces: this.$i18n.t('detailClient.dispositif.tab.nbFaces'),
          typeMateriel: this.$i18n.t('detailClient.dispositif.tab.typeMateriel'),
          nomCommercial: this.$i18n.t('detailClient.dispositif.tab.site'),
          'dispositifType.libelle': this.$i18n.t('detailClient.dispositif.tab.type'),
          etat: this.$i18n.t('detailClient.dispositif.tab.etatMontage'),
          actif: this.$i18n.t('detailClient.dispositif.tab.archive'),
          formats: this.$i18n.t('detailClient.dispositif.tab.materielFormats'),
          tailles: this.$i18n.t('detailClient.dispositif.tab.tailles'),
          eclairerOuNon: this.$i18n.t('detailClient.dispositif.tab.eclaire'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: this.selectAll,
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: [],
        childRow: materielsForClients,
        columnsClasses: {
          selected: 'colonneSelected',
        },
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'dispositifs',
        typeExport: 'client',
        filtres: {
          query: {
            clientIds: this.tabCustomerIds,
            societeId: this.societeActiveId,
          },
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getAgenceLibelle(agenceId) {
      return this.agencesSelectionnees.find(a => a.agenceId === agenceId)?.libelleAgence ?? '';
    },
    getDispositifTypeLibelle(id) {
      return this.parametre(PARAMETRES_KEYS.dispositifType).find((dispositif) => dispositif.id === id)?.libelle ?? '';
    },
    getEtatMontage(codeEtat) {
      return ETAT_DISPOSITIF_PUBLICITAIRE.find(e => e.value === codeEtat)?.libelle ?? '';
    },
    getAdresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
    createListAllTiers(tiers) {
      this.listTiers.push({
        id: this.tiersInformation.id,
        nomCommercial: this.tiersInformation.nomCommercial,
      });
      tiers.forEach((tiersEnfant) => {
        this.listTiers.push({
          id: tiersEnfant.id,
          nomCommercial: tiersEnfant.nomCommercial,
        });
        tiersEnfant.tiersEnfants.forEach((el) => {
          this.listTiers.push({
            id: el.id,
            nomCommercial: el.nomCommercial,
          });
        });
      });
    },
    updateSelected(dispositifTochange) {
      const dispositif = this.dispositifs.find(d => d.id === dispositifTochange.id);
      if (dispositif) this.$set(dispositif, 'selected', !dispositifTochange.selected);
    },
    selectAll() {
      const allSelected = this.allSelected;
      this.dispositifs.forEach(dispo => { dispo.selected = !allSelected; });
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_CREATION_DEMANDE_IMPRESSION:
          this.popUpCreationDemandeImpression = true;
          break;
        default:
          break;
      }
    },
    getNomCommercial(id) {
      return this.listTiers.find((el) => el.id === id)?.nomCommercial;
    },
    getAllFormats(materiels) {
      return [...new Set(materiels.map(materiel => materiel.format.libelle))].join(', ');
    },
    getAllTypeMateriel(materiels) {
      return [...new Set(materiels.map(materiel => materiel.type.libelle))].join(', ');
    },
    getAllEclairage(materiels) {
      return [...new Set(materiels.map(({ eclaire }) => eclaire))]
        .map(eclaire => this.$t(eclaire ? 'general.oui' : 'general.non'))
        .join(', ');
    },
    getAllTailles(materiels) {
      return formatTaillesMateriels(materiels);
    },
    async loadDispositifs() {
      const tabClientIds = this.listTiers.map((el) => el.id);
      this.tabCustomerIds = tabClientIds;
      this.dispositifs = (await getAll({
        query: {
          clientIds: tabClientIds,
          societeId: this.societeActiveId,
          brouillon: null,
        },
      })).data.result.items;
      this.dispositifs.forEach(d => {
        this.$set(d, 'selected', false);
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const liensInferieurs = (
        await getWithLiensInferieurs(this.tiersInformation.id, true)
      ).data.result?.tiersEnfants;
      this.createListAllTiers(liensInferieurs);
      await this.loadDispositifs();
      await this.loadParametres([PARAMETRES_KEYS.dispositifType]);
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
